import React from 'react'
import CheckList from '../CheckList'
import _ from 'lodash'

const CheckListWrapper = ({ entity }) => {
  const title = entity.fieldTitle;
  const items = _.get(entity, 'fieldItem', [])

  return (
    <CheckList title={title} items={items} />
  )
}

export default CheckListWrapper
